module.exports = "<div class=\"loading\">Loading&#8230;</div>"